<template>
  <li
    class="sidebar-sub-item"
    :class="[isActive ? 'text-default' : 'text-default/40', {'bg-active' : isActive && !props.children}]"
    @click="sidebarClick"
    :style="{gap: labelGap}"
  >
    <div
      class="w-1"
      :class="{'bg-active-bar' : isParentActive}"
    />
    <div class="flex min-w-0 grow items-center justify-between p-2">
      <p>{{ props.label }}</p>
      <div class="flex gap-2">
        <EpIcon
          v-if="props.isExternalLink"
          name="launch"
          :size="20"
          :class="{'text-default/40' : !isActive}"
        />
      </div>
    </div>
  </li>
  <template v-if="props.children && props.children.length > 1">
    <SidebarSubMenu
      v-for="menu in props.children"
      :key="menu.value"
      v-bind="{
        ...menu,
        parentUrl: `${props.parentUrl}/${props.value}`,
        depth: props.depth + 1,
      }"
    />
  </template>
</template>

<script setup lang="ts">
import EpIcon from '~/components/icon/EpIcon.vue'
import { useSidebar } from '~/composables/useSidebar'
import type { ISubMenuRoute } from '~/types/sidebar-menu.type'

const props = defineProps<ISubMenuRoute>()
const { isActive, isParentActive, sidebarClick } = useSidebar(props)
const labelGap = computed(() => `${(2 + 4 * props.depth) * 0.25}rem`)
</script>

<style scoped lang="scss">
.sidebar-sub-item {
  @apply flex w-full cursor-pointer;
  transition: all 0.3s ease;

  &:hover {
    @apply bg-gradient-to-r from-default/10 to-transparent text-default;
  }
}

.bg-active-bar {
  @apply bg-primary;
}

.bg-active {
  &, &:hover {
    @include background-gradient;
  }
}
</style>